<template>
    <div>
        <div class="form-row col-12 px-0">
            <div class="col-md-6 form-group">
                <datepicker-accessible
                    :label-single="'Od'"
                    custom-id="date-from"
                    name="date-from"
                    mode="date"
                    :use_pencil_checkbox="false"
                    :strong_label="false"
                    v-model="dateFrom"
                ></datepicker-accessible>
                <small class="text-red small-70" v-if="!validDate">
                    {{ $lang('Data musi być wcześniejsza niż data końcowa') }}
                </small>
            </div>

            <div class="col-md-6 form-group">
                <datepicker-accessible
                    :label-single="'Do'"
                    custom-id="date-to"
                    name="date-to"
                    mode="date"
                    :use_pencil_checkbox="false"
                    :strong_label="false"
                    v-model="dateTo"
                ></datepicker-accessible>
                <small class="text-red small-70" v-if="!validDate">
                    {{ $lang('Data musi być późniejsza niż data początkowa') }}
                </small>
            </div>
        </div>

        <div class="form-group">
            <label for="library_id">{{$lang('Biblioteka')}}</label>
            <select id="library_id" name="library_id" class="form-control" v-model="query.libraryID">
                <option :value=0>{{$lang('Wszystkie')}}</option>
                <option v-for="library in libraries" :value="library.id">{{library.name}}</option>
            </select>
        </div>


        <div class="form-group" :class="{'mb-0': !filters.modules}">
            <input type="checkbox" class="mr-2" id="filter_modules" name="filter_modules" v-model="filters.modules"/>
            <label for="modules">{{$lang('Wybrane moduły')}}</label>
            <multiselect
                v-if="filters.modules"
                :searchable=false :close-on-select=false
                id="modules" v-model="query.modules" :options="[{label: 'Wszystkie', options: modules}]"
                group-values="options" group-label="label" :group-select="true"
                :multiple="true" label="name" track-by="id"
                :placeholder="$lang('Wybierz moduły')"
                :selectLabel="$lang('Wybierz moduł')"
                :selectedLabel="$lang('Wybrane')"
                :deselectLabel="$lang('Usuń moduł')"
                :selectGroupLabel="$lang('Wybierz wszystkie moduły')"
                :deselectGroupLabel="$lang('Usuń wszystkie moduły')"
            ></multiselect>

            <template v-if="filters.modules">
                <input v-for="module in query.modules" name="modules[]" :value="module.id" hidden>
            </template>
        </div>

        <div class="form-group" :class="{'mb-0': !filters.criteria}">
            <input type="checkbox" class="mr-2" id="filter_criteria" name="filter_criteria" v-model="filters.criteria"/>
            <label for="criteria">{{$lang('Wybrane kryteria')}}</label>
            <multiselect
                v-if="filters.criteria"
                :searchable=false :close-on-select=false
                id="criteria" v-model="query.criteria" :options="[{label: 'Wszystkie', options: criteria}]"
                group-values="options" group-label="label" :group-select="true"
                :multiple="true" label="name" track-by="id"
                :placeholder="$lang('Wybierz kryteria')"
                :selectLabel="$lang('Wybierz kryterium')"
                :selectedLabel="$lang('Wybrane')"
                :deselectLabel="$lang('Usuń kryterium')"
                :selectGroupLabel="$lang('Wybierz wszystkie kryteria')"
                :deselectGroupLabel="$lang('Usuń wszystkie kryteria')"
            ></multiselect>

            <template v-if="filters.criteria">
                <input v-for="criterion in query.criteria" name="criteria[]" :value="criterion.id" hidden>
            </template>
        </div>

        <div class="form-group" :class="{'mb-0': !filters.statuses}">
            <input type="checkbox" class="mr-2" id="filter_statuses" name="filter_statuses" v-model="filters.statuses"/>
            <label for="statuses">{{$lang('Wybrane statusy')}}</label>
            <multiselect
                v-if="filters.statuses"
                :searchable=false :close-on-select=false
                id="statuses" v-model="query.statuses" :options="[{label: 'Wszystkie', options: statuses}]"
                group-values="options" group-label="label" :group-select="true"
                :multiple="true" label="name" track-by="id"
                :placeholder="$lang('Wybierz statusy')"
                :selectLabel="$lang('Wybierz status')"
                :selectedLabel="$lang('Wybrane')"
                :deselectLabel="$lang('Usuń status')"
                :selectGroupLabel="$lang('Wybierz wszystkie statusy')"
                :deselectGroupLabel="$lang('Usuń wszystkie statusy')"
            ></multiselect>

            <template v-if="filters.statuses">
                <input v-for="status in query.statuses" name="statuses[]" :value="status.id" hidden>
            </template>

        </div>

        <div class="form-group" :class="{'mb-0': !filters.consultants}">
            <input type="checkbox" class="mr-2" id="filter_consultants" name="filter_consultants" v-model="filters.consultants"/>
            <label for="consultants">{{$lang('Wybrani konsultanci')}}</label>
            <multiselect
                v-if="filters.consultants"
                :searchable=false :close-on-select=false
                id="consultants" v-model="query.consultants" :options="[{label: 'Wszystkie', options: consultants}]"
                group-values="options" group-label="label" :group-select="true"
                :multiple="true" label="name"  track-by="id"
                :placeholder="$lang('Wybierz konsultantów')"
                :selectLabel="$lang('Wybierz konsultanta')"
                :selectedLabel="$lang('Wybrani konsultanci')"
                :deselectLabel="$lang('Usuń konsultanta')"
            ></multiselect>
            <template v-if="filters.consultants">
                <input  v-for="person in query.consultants" name="consultants[]" :value="person.id" hidden>
            </template>
        </div>

        <div class="form-group" :class="{'mb-0': !filters.rates}">
            <input type="checkbox" class="mr-2" id="filter_rates" name="filter_rates" v-model="filters.rates"/>
            <label for="rates">{{$lang('Wybrane oceny')}}</label>
            <multiselect
                v-if="filters.rates"
                :searchable=false :close-on-select=false
                id="rates" v-model="query.rates" :options="[{label: 'Wszystkie', options: rates}]"
                group-values="options" group-label="label" :group-select="true"
                :multiple="true" label="name"  track-by="id"
                :placeholder="$lang('Wybierz oceny')"
                :selectLabel="$lang('Wybierz ocenę')"
                :selectedLabel="$lang('Wybrane oceny')"
                :deselectLabel="$lang('Usuń ocenę')"
            ></multiselect>
            <template v-if="filters.rates">
                <input  v-for="rate in query.rates" name="rates[]" :value="rate.id" hidden>
            </template>
        </div>

        <div class="form-group mb-0 mt-3">
            <input type="checkbox" id="client_only" name="client_only" v-model="query.onlyClient"/>
            <label for="client_only">{{ $lang('Tylko oceny nadane przez klienta') }}</label>
        </div>
        <div class="form-group">
            <input type="checkbox" id="add_comment" name="add_comment" v-model="query.withComment"/>
            <label for="add_comment">{{ $lang('Prezentuj komentarze dodane do oceny') }}</label>
        </div>

        <div class="form-group" v-if="separationAvailable">
            <label for="separate_by">{{$lang('Podział')}}</label>
            <select id="separate_by" name="separate_by" class="form-control" v-model="separateBy">
                <option :value="null">{{$lang('bez podziału')}}</option>
                <option v-if="separateByLibrary" value="tasks.library_id">{{$lang('wg biblioteki')}}</option>
                <option v-if="separateByConsultant" value="tasks.consultant_id">{{$lang('wg konsultanta')}}</option>
                <option v-if="separateByCriterion" value="tasks.criterion">{{$lang('wg kryterium')}}</option>
                <option v-if="separateByModule" value="tasks.module">{{$lang('wg modułu')}}</option>
                <option v-if="separateByRate" value="task_feedback.rate">{{$lang('wg oceny')}}</option>
            </select>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import ValidDate from "../../../mixins/report-valid-date";
import DatepickerAccessible from "../../datepicker-accessible.vue";
import moment from "moment";

export default {
    components: {DatepickerAccessible, Multiselect},
    mixins: [ValidDate],
    props: ['libraries', 'modules', 'criteria', 'statuses', 'consultants', 'rates'],
    data() {
        return {
            separateBy: null,
            filters: {
                modules: false,
                criteria: false,
                statuses: false,
                consultants: false,
                rates: false,
            },
            query: {
                libraryID: 0,
                modules: [],
                criteria: [],
                statuses: [],
                consultants: [],
                rates: [],
                onlyClient: false,
                withComment: false,
            }
        }
    },
    computed: {
        valid() {
            return this.dateFrom !== '-' && this.dateTo !== '-' && this.dateFrom <= this.dateTo
                && (!this.filters.modules || this.query.modules.length > 0)
                && (!this.filters.criteria || this.query.criteria.length > 0)
                && (!this.filters.statuses || this.query.statuses.length > 0)
                && (!this.filters.consultants || this.query.consultants.length > 0)
                && (!this.filters.rates || this.query.rates.length > 0);
        },
        separateByLibrary() {
            return !this.query.libraryID;
        },
        separateByConsultant() {
            return !this.filters.consultants || this.query.consultants.length > 1;
        },
        separateByCriterion() {
            return !this.filters.criteria || this.query.criteria.length > 1;
        },
        separateByModule() {
            return !this.filters.modules || this.query.modules.length > 1;
        },
        separateByRate() {
            return !this.filters.rates || this.query.rates.length > 1;
        },
        separationAvailable() {
            return this.separateByConsultant || this.separateByCriterion || this.separateByModule || this.separateByLibrary || this.separateByRate();
        }
    },
    watch: {
        valid() {
            this.$emit('validation', this.valid);
        }
    },
    created() {
        this.dateFrom = moment().startOf('year').format('YYYY-MM-DD');
        this.dateTo = moment().endOf('year').format('YYYY-MM-DD');
    }
}
</script>
